import { ORGANIZATION_ID, absolute } from "../../components/SEO.jsx"

// Service JSON-LD for a data-driven service page. Everything here mirrors
// content that is visible on the page: the service name, its description,
// the "included" items and, where present, the highlighted feature.
export function buildServiceSchema(service) {
  const { page } = service
  if (!page.schema) return []

  const url = absolute(service.path)
  const offers = page.included.map((item) => ({
    "@type": "Offer",
    itemOffered: { "@type": "Service", name: item.title, description: item.text },
  }))

  if (page.feature) {
    offers.push({
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: page.feature.heading,
        description: page.feature.lead,
        url: `${url}#${page.feature.id}`,
      },
    })
  }

  return [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "@id": `${url}#service`,
      name: service.title,
      serviceType: page.schema.serviceType,
      description: page.seoDescription,
      url,
      provider: { "@type": "Organization", "@id": ORGANIZATION_ID, name: "2merative" },
      areaServed: [
        { "@type": "City", name: "Adelaide" },
        { "@type": "State", name: "South Australia" },
        { "@type": "Country", name: "Australia" },
      ],
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: `${service.title} services`,
        itemListElement: offers,
      },
    },
  ]
}
